/**
 * AutoLux Stats Counter
 * Numbers count up from 0 on viewport entry.
 */
(function () {
  'use strict';

  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function easeOutExpo(t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); }

  function countUp(el, target, duration) {
    var start = performance.now();
    var isFloat = (target % 1 !== 0);
    var decimals = isFloat ? 1 : 0;
    function step(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeOutExpo(progress);
      var current = eased * target;
      el.textContent = current.toFixed(decimals).replace('.', ',');
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(decimals).replace('.', ',');
    }
    requestAnimationFrame(step);
  }

  function init() {
    var numbers = document.querySelectorAll('.al-stats__number[data-count]');
    if (!numbers.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.dataset.count);
        var duration = parseInt(el.dataset.duration || '2000', 10);
        if (!isNaN(target)) countUp(el, target, duration);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    numbers.forEach(function (n) { io.observe(n); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    requestAnimationFrame(function () { requestAnimationFrame(init); });
  }
})();
